import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Subscription} from "rxjs";
import {ProcessAbbyyService} from "../../../core/services/process-abbyy.service";
import {NotificationService} from "@progress/kendo-angular-notification";
import {showNotification} from "../../utilities/notificaton.util";
import {LoaderService} from "../../../core/services/loader.service";

@Component({
    selector: 'app-immediate-mark',
    templateUrl: './immediate-mark.component.html',
    styleUrls: ['./immediate-mark.component.scss'],
    standalone: false
})
export class ImmediateMarkComponent {
  public markingAsError: Subscription;
  @Input() lluSearchRequired = false;
  @Input() patient: any;
  @Input() formId: any;
  @Output() buttonClicked = new EventEmitter<void>();
  constructor(private abbyyService: ProcessAbbyyService, private notificationService: NotificationService,
              private loader: LoaderService) {
  }
  async markAsInvalid(status: any) {
    if (this.lluSearchRequired && this.patient === undefined) {
      showNotification('Please search for patient before rejecting.', 'error', this.notificationService);
    } else {
      try {
        this.loader.show('Marking as Error ...');
        await this.abbyyService.markAsError(this.formId, status, this.patient == undefined ? null : this.patient);
        showNotification('Form Rejected', 'success', this.notificationService);
        this.buttonClicked.emit();
      } catch (err) {
        showNotification('An Error Occurred', 'error', this.notificationService)
      } finally {
        this.loader.hide();
      }
    }
  }
}
